import type { TenantConfig } from '@/types/TenantConfig'

const green = '#46A381'
const blue = '#436984'
const pink = '#DE5767'
const footer = '#1E272B'

export const sbt: TenantConfig = {
  logo: 'https://www.shakespeare.org.uk/static/img/logo-red.svg',
  teaserImageSize: {
    width: 320,
  },
  themeOptions: {
    primaryColor: pink,
    secondaryColor: pink,
    logoHeight: '62px',
    headerHeight: '100px',
    headerBackground: green,
    memberLinksColor: 'white',
    cartHeaderBackgroundColor: blue,
    cartHeaderTextColor: 'white',
    footerBackgroundColor: footer,
    footerTextColor: 'white',
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/sbt/static/complete.jpeg',
      },
      completedContentOffset: {
        desktop: '-180px',
        mobile: '-110px',
      },
    },
  },
}
